export const preloadMedia = (
  url: string,
  mediaType: string,
  onReady: () => void,
  onError: () => void,
): void => {
  if (mediaType === 'video') {
    const video = document.createElement('video');
    video.src = url;
    video.muted = true;
    video.oncanplaythrough = onReady;
    video.onerror = onError;
    video.load();
  } else {
    const img = new Image();
    img.onload = onReady;
    img.onerror = onError;
    img.src = url;
  }
};

export const syncVideoTiming = (
  currentRef: HTMLVideoElement | null,
  nextRef: HTMLVideoElement | null,
): void => {
  if (currentRef && nextRef) {
    try {
      nextRef.currentTime = currentRef.currentTime;
    } catch {
      // Sync errors are expected and can be ignored
    }
  }
};

export const performTransition = (
  setShowNext: (value: boolean) => void,
  setShowCurrent: (value: boolean) => void,
  onComplete: () => void,
): void => {
  setShowNext(true);
  setTimeout(() => {
    setShowCurrent(false);
    setTimeout(onComplete, 50);
  }, 50);
};

export const controlVideoPlayback = (
  videoRef: HTMLVideoElement | null,
  isPaused: boolean,
): void => {
  if (!videoRef) return;

  if (isPaused) {
    videoRef.pause();
  } else {
    videoRef.play().catch(() => {
      // Autoplay errors are expected and can be ignored
    });
  }
};
